// extracted by mini-css-extract-plugin
export default {"table":"Table_table__87wYI","table__title":"Table_table__title__mzioq","table__head":"Table_table__head__TSMri","table__body":"Table_table__body__pFFm3"};